export const sustainability = {
  hero: {
    title: '可持续承诺',
    subtitle: '清洁标签，绿色循环',
    description: '膳兜兜相信，真正的健康不仅是产品对身体的滋养，更是品牌对地球的责任。从原料采购到包装设计，我们坚持全链路的可持续实践。',
  },
  commitments: [
    {
      title: '清洁标签承诺',
      description: '拒绝化学添加剂的过度修饰。每一款产品配料表上的每一个成分，都是你能读得懂、查得到的天然食材。没有复杂的化学名称，只有大自然的馈赠。',
      stats: [
        { value: '0', label: '人工色素' },
        { value: '0', label: '人工香精' },
        { value: '0', label: '防腐剂' },
        { value: '100%', label: '可溯源' },
      ],
    },
    {
      title: '绿色供应链',
      description: '深入全球36个优质原产地，与有机农场建立长期合作。优先选择符合公平贸易标准的供应商，确保每一克原料都来自负责任的种植与采集。',
      stats: [
        { value: '36', label: '全球产地' },
        { value: '100%', label: '原料检测' },
        { value: '50%+', label: '有机合作' },
        { value: '0', label: '转基因' },
      ],
    },
    {
      title: '循环包装设计',
      description: '采用FSC认证纸张、可降解生物基材料和可回收铝箔包装。在产品陈列美观与环保责任之间，我们从不做选择题——两者都要。',
      stats: [
        { value: '100%', label: 'FSC纸张' },
        { value: '80%', label: '可降解材' },
        { value: '0', label: '一次性塑' },
        { value: '50%', label: '碳减排' },
      ],
    },
    {
      title: '碳中和目标',
      description: '通过优化生产工艺、采购绿色电力、支持林业碳汇项目，膳兜兜承诺在2030年前实现全链路碳中和。我们正在用数据丈量每一步的碳足迹。',
      stats: [
        { value: '30%', label: '当前减排' },
        { value: '2030', label: '碳中和年' },
        { value: '100%', label: '绿电使用' },
        { value: '∞', label: '持续优化' },
      ],
    },
  ],
  certifications: {
    title: '权威认证',
    subtitle: '膳兜兜的产品和流程已获得多项国内外权威认证',
    list: [
      { name: 'ISO 22000', desc: '食品安全管理体系' },
      { name: 'HACCP', desc: '危害分析关键控制点' },
      { name: '有机认证', desc: '中国有机产品认证' },
      { name: 'FSC', desc: '森林管理委员会认证' },
      { name: '清洁标签', desc: '国际清洁标签联盟' },
      { name: '碳足迹', desc: '产品全生命周期碳足迹认证' },
    ],
  },
  report: {
    title: '年度可持续报告',
    description: '我们每年发布《膳兜兜可持续发展报告》，透明公开品牌在环保、社会责任和公司治理方面的进展与目标。',
    cta: '下载最新报告',
  },
};